import { connect } from 'react-redux';
import ChangeRequestRow from './ChangeRequestRow';
import { sortChangeRequestRequest, updateChangeRequestFlag } from '../../../../../store/actions/changeRequests.actions';

const mapDispatchToProps = { sortChangeRequestRequest, updateFlag: updateChangeRequestFlag };

export default connect(null, mapDispatchToProps)(ChangeRequestRow);